/* eslint-disable no-console */
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    process: 'checkout',
  }),
  computed: {
    ...mapGetters([
      '_T',
      'cart_sub_total',
      'cart_items_count',
      'is_customer_logged_in',
      'guest_checkout',
      'brandStoreRoute',
      'brandStoreParams',
      'selected_order',
      'order_total_inc_cashback',
      'customer_saved_credit_cards',
      'processInProgress',
      'loyalty_spent',
      'currentStore',
      'isStoreOpen',
      'isFloorTableAvailable',
      'currentStoreId',
    ]),
    btnDisabled() {
      if (!this.cart_items_count) {
        return true
      }
      if (this.guest_checkout) {
        return this.processInProgress(this.process)
      }
      if (!this.is_customer_logged_in) {
        return true
      }
      return this.processInProgress(this.process)
    },
  },
  watch: {},
  methods: {
    checkout() {
      let context = this
      if (this.btnDisabled && !this.isFloorTableAvailable.table_id) {
        return false
      }

      this.$store.dispatch('startProcess', {
        process: this.process,
        progress: true,
      })
      console.log('validating checkout')
      this.$store
        .dispatch('validatePayments')
        .then(() => {
          console.log('- validated checkout')
          console.log('setting up payment')
          this.$store
            .dispatch('setPayment')
            .then(() => {
              console.log('- payment validated')
              console.log('sending request to server')
              this.$store
                .dispatch('checkout')
                .then(() => {
                  console.log('request successfully sent to server')
                  console.log('show msg success')
                  if (
                    this.isFloorTableAvailable.table_id &&
                    context.selected_order._id
                  ) {
                    this.$store.dispatch('showNotification', {
                      text: this._T(
                        'Thank you for adding more items, we will serve you soon.'
                      ),
                      status: 'success',
                    })
                  } else {
                    this.$store.dispatch('showNotification', {
                      text: this._T('Order has been placed successfully'),
                      status: 'success',
                    })
                  }
                  console.log(
                    'trackorder, change route',
                    this.currentStoreId,
                    this.currentStoreSlug
                  )
                  console.log('last order', this.$store.getters.last_order_request)
                  // add redirection here regarding order status
                  // here need to add order status QrTableOrderStatus
                  let order_id =
                    context.selected_order.id || context.selected_order._id
                  this.$router.replace({
                    name: this.brandStoreRoute('track-order'),
                    params: {
                      store_id: this.currentStoreSlug || this.$store.getters.last_order_request.store_id,
                      order_id: order_id,
                    },
                  })

                  console.log('do post checkout')
                  this.$store.dispatch('doPostCheckout')
                })
                .catch(error => {
                  console.log(
                    'request to server failed, please see below error'
                  )
                  // eslint-disable-next-line no-console
                  console.log(error)
                  console.trace(error)

                  let errorString = ''

                  if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx

                    // console.log(error.response.data)
                    // console.log(error.response.status)
                    // console.log(error.response.headers)

                    errorString = `Server returned an error, status: ${error.response.status}, data: ${error.response.data}.`
                  } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js

                    //console.log(error.request)
                    let requestError =
                      error.request.message || error.request.statusText
                    if (!requestError) {
                      errorString = `You have unstable network.`
                      if (error.message === 'Network Error') {
                        errorString += ` Error: ${error.message}`
                      }
                    } else {
                      errorString = `Server didn't respond, request: ${requestError}`
                    }
                  } else if (error.message) {
                    // Something happened in setting up the request that triggered an Error
                    //console.log('Error', error.message)
                    errorString = `Something went wrong: ${error.message}.`
                  } else if (typeof error === 'object') {
                    let str = ''
                    for (const i in error) {
                      str += i + ':' + error[i] + '\n'
                    }
                    errorString = str
                  } else if (error) {
                    errorString = error
                  } else {
                    errorString = 'You have unstable network.'
                  }

                  errorString += '. Please try again later.'

                  this.$store.dispatch('showNotification', {
                    text: this._T(errorString),
                    status: 'error',
                  })
                })
                .finally(result => {
                  console.log('get out of request, details ', result)
                  this.$store
                    .dispatch('stopProcess', this.process)
                    .then(() => {})
                })
            })
            .catch(error => {
              console.log('Payment setup was failed', error)
              this.$store.dispatch('stopProcess', this.process).then(() => {})
            })
            .finally(result => {
              console.log('get out of payment setup, details ', result)
            })
        })
        .catch(error => {
          console.log('checkout validation was failed', error)
          this.$store.dispatch('stopProcess', this.process)
        })
        .finally(result => {
          console.log('get out of validation checkout, details ', result)
        })
    },
  },
}
